import { formatSupportDate } from './support/supportFormat';
import { OrbitPlannedWindow } from './types';

const DAY_MS = 24 * 60 * 60 * 1000;

const MIDNIGHT = /^(\d{4})-(\d{2})-(\d{2})[ T]00:00(?::00)?/;

/** The last day the window covers: `end_date` is exclusive, so a midnight end is the day before. */
const lastDay = (endDate: string): string => {
  const match = MIDNIGHT.exec(endDate);

  if (match === null) {
    return endDate;
  }

  const [, year, month, day] = match;

  return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)) - DAY_MS)
    .toISOString()
    .slice(0, 10);
};

export interface IOrbitPlannedWindowDays {
  /** `null` for a cohort answer, which has no start. */
  first: string | null;
  last: string;
}

/** The window's first and last day, in the support blocks' date format. */
export const orbitPlannedWindowDays = (window: OrbitPlannedWindow): IOrbitPlannedWindowDays => ({
  first: window.start_date === null ? null : formatSupportDate(window.start_date),
  last: formatSupportDate(lastDay(window.end_date))
});
